import { trackEvent } from 'frontend/shared/javascripts/util/analytics'

interface AnalyticsTrackInputChangesEvent extends Event {
  elementId?: string
}

up.on(
  'analytics:track-input-changes',
  (event: AnalyticsTrackInputChangesEvent, element: HTMLElement | undefined) => {
    if (element != null) {
      trackEvent('change.input', { element: { id: event.elementId } })
    }
  },
)
